import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import {
  InventoryOwnerDto,
  InventoryWarehouseDto,
  JniStoreDto,
} from "../models/inventory/inventory-lookup.models";

@Injectable({
  providedIn: "root",
})
export class InventoryLookupService {
  private baseUrl = environment.baseUrl + "/ClientManagement";

  constructor(private _http: HttpClient) {}

  getStores(): Observable<GenericResponseDto<JniStoreDto[]>> {
    return this._http.get<GenericResponseDto<JniStoreDto[]>>(
      `${this.baseUrl}/GetAllStores`
    );
  }

  getWarehouses(): Observable<GenericResponseDto<InventoryWarehouseDto[]>> {
    return this._http.get<GenericResponseDto<InventoryWarehouseDto[]>>(
      `${this.baseUrl}/GetAllWarehouses`
    );
  }

  getOwnersByStoreAndWarehouse(
    store: string,
    warehouse: string
  ): Observable<GenericResponseDto<InventoryOwnerDto[]>> {
    return this._http.get<GenericResponseDto<InventoryOwnerDto[]>>(
      `${this.baseUrl}/GetOwnersByStoreAndWarehouse?store=${encodeURIComponent(store)}&warehouse=${encodeURIComponent(warehouse)}`
    );
  }

  getSiteByWarehouse(
    warehouseId: string
  ): Observable<GenericResponseDto<string>> {
    return this._http.get<GenericResponseDto<string>>(
      `${this.baseUrl}/GetSiteByWarehouse?warehouseId=${encodeURIComponent(warehouseId)}`
    );
  }
}
